export default{
  state(){
    return{
      mustHavePayment: null,//true：支払方法要設定、false：支払方法設定不要
      personalPaymentTarget: true, //true:個人課金対象、false：個人課金対象外 || ログインする際ときのみ値を設定する
    };
  },
  getters:{
    getMustHavePayment(state){
      return state.mustHavePayment;
    },
    getPersonalPaymentTarget(state){
      return state.personalPaymentTarget;
    }
  },

  mutations:{
    setMustHavePayment(state, value){
      state.mustHavePayment = value;
    },
    setPersonalPaymentTarget(state, value){
      state.personalPaymentTarget = value;
    }
  }
}